<template>
    <tr class="counts-tool-field-container">
        <td class="field-name">
            <strong>{{field.properties.Name}}</strong>
        </td>
        <td>
            {{field.properties.FieldType}}
        </td>
        <td class="counts-tool-group-by">
            <FormInputGroupView
                v-bind:inputs="form.inputs.groupBy"
                v-bind:values="form.values"
                v-on:FormInputGroup:change="formChange"
            />
        </td>
        <td>
            <div v-if="form.values.groupBy == 'true'">
                <FormInputGroupView
                    v-if="field.properties.FieldType == 'EmailAddress'"
                    v-bind:inputs="form.inputs.configEmail"
                    v-bind:values="form.values"
                    v-on:FormInputGroup:change="formChange"
                />
                <FormInputGroupView
                    v-if="field.properties.FieldType == 'Decimal'"
                    v-bind:inputs="form.inputs.configDecimal"
                    v-bind:values="form.values"
                    v-on:FormInputGroup:change="formChange"
                />
                <FormInputGroupView
                    v-if="field.properties.FieldType == 'Date'"
                    v-bind:inputs="form.inputs.configDate"
                    v-bind:values="form.values"
                    v-on:FormInputGroup:change="formChange"
                />
                <FormInputGroupView
                    v-bind:inputs="form.inputs.customSQLExpressionEnabled"
                    v-bind:values="form.values"
                    v-on:FormInputGroup:change="formChange"
                />
                <FormInputGroupView
                    v-bind:inputs="form.inputs.customSQLExpression"
                    v-bind:values="form.values"
                    v-on:FormInputGroup:change="formChange"
                />
            </div>
        </td>
    </tr>
</template>

<script>
import FormInputGroupView, { FormInputGroup } from '@/components/form-input-group2/FormInputGroup';

var formGroups = (fieldName) => {
    var fieldNameSQL = (
        fieldName.match(/^[a-zA-Z][_A-Za-z0-9]*$/) ? fieldName : `[${fieldName}]`
    );
    return {
        groupBy: [
            {
                "key": "groupBy",
                //"label": `Group by ${fieldName}`,
                "label": `Group by`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            }
        ],
        configEmail: [
            {
                "key": "groupByDomain",
                "label": `Group by domain`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            }
        ],
        configDecimal: [
            {
                "key": "roundDecimal",
                "label": `Group by value rounded to <em>N</em> decimal places`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            },
            {
                "key": "decimalPlacesDecimal",
                "label": `Decimal places`,
                "attrs": {
                    "type": "text",
                    "pattern": '^[0-9]+$',
                    "required": true
                },
                "classesCss": "decimal-places-decimal"
            }
        ],
        configDate: [
            {
                "key": "groupByFormatDate",
                "label": "Group by formatted date",
                "attrs": {
                    "type": "select"
                },
                "options": [
                    {
                        "label": "none - raw value",
                        "value": ""
                    },
                    {
                        "label": "yyyy (4-digit year)",
                        "value": "yyyy"
                    },
                    {
                        "label": "yyyy-MM (4-digit year, month)",
                        "value": "yyyy-MM"
                    },
                    {
                        "label": "yyyy-MM-dd (4-digit year, month, day)",
                        "value": "yyyy-MM-dd"
                    },
                    {
                        "label": "yyyy-MM-dd H:00:00 (4-digit year, month, day, hour)",
                        "value": "yyyy-MM-dd H:00:00"
                    },
                    {
                        "label": "MM (month)",
                        "value": "MM"
                    },
                    {
                        "label": "H (hour)",
                        "value": "H"
                    },
                    {
                        "label": "Months ago from today - datediff(month, [field_name], getdate())",
                        "value": "datediff-month" // datediff(month, src.last_engagement_date, getdate())
                    },
                    {
                        "label": "Quarters ago from today - datediff(quarter, [field_name], getdate())",
                        "value": "datediff-quarter" // datediff(quarter, src.last_engagement_date, getdate())
                    }
                ]
            }
        ],
        customSQLExpressionEnabled: [
            {
                "key": "customSQLExpressionEnabled",
                "label": `Use custom SQL expression`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            }
        ],
        customSQLExpression: [
            {
                "key": "customSQLExpression",
                "label": `Custom SQL expression`,
                "attrs": {
                    "type": "textarea",
                    "disabled": true
                },
                'helperText': [
                    `Use the alias <code>src</code> to refer to the selected DE - e.g. <code>src.${fieldNameSQL}</code>`
                ],
                classesCss: ['counts-tool-field-custom-sql-expression']
            }
        ]
    };
};

export var inputDefaultValues = {
    groupBy: 'false',
    groupByDomain: 'true',
    roundDecimal: 'true',
    decimalPlacesDecimal: '2',
    groupByFormatDate: 'yyyy-MM-dd',
    customSQLExpressionEnabled: 'false',
    customSQLExpression: ''
};

var inputCustomSQLValues = {
    groupByDomain: 'false',
    roundDecimal: 'false',
    decimalPlacesDecimal: '2',
    groupByFormatDate: ''
};

export default {
    name: 'CountsToolFieldView',
    components: {
        FormInputGroupView
    },
    props: {
        "field": Object,
        "fieldKey": String
    },
    data: function() {
        var inputs = formGroups(this.field.properties.Name);
        return {
            form: {
                inputs: FormInputGroup.makeInputs(inputs),
                values: FormInputGroup.makeValues(inputs, this.field.values)
            }
        }
    },
    created: function() {
        this.formInputs = FormInputGroup.util(() => this.form.inputs);
    },
    methods: {
        formChange: function(event) {
            this.form.values[event.key] = event.value;
            this.$emit(
                'CountsToolField:update',
                this.fieldKey,
                JSON.parse(JSON.stringify(this.form.values))
            );
        }
    },
    watch: {
        'form.values.customSQLExpressionEnabled': function(value) {
            if (value == 'true') {
                Object.keys(inputCustomSQLValues).forEach((inputKey) => {
                    this.form.values[inputKey] = inputCustomSQLValues[inputKey];
                    this.formInputs.get(inputKey).attrs.disabled = true;
                });
                this.form.values.customSQLExpression = (
                    `src.${this.field.properties.Name.match(/^[a-zA-Z][_A-Za-z0-9]*$/) ? this.field.properties.Name : `[${this.field.properties.Name}]`}`
                );
                this.formInputs.get('customSQLExpression').attrs.disabled = false;
            } else {
                Object.keys(inputCustomSQLValues).forEach((inputKey) => {
                    this.form.values[inputKey] = inputDefaultValues[inputKey];
                    this.formInputs.get(inputKey).attrs.disabled = false;
                });
                this.form.values.customSQLExpression = (
                    inputDefaultValues.customSQLExpression
                );
                this.formInputs.get('customSQLExpression').attrs.disabled = true;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
